import { olHeaders } from './olHeaders';

export const useUserLoggedInConfigs = {
  config: {
    olHeaders,
    skip: false
  }
};

export const useFeatureFlagsConfigs = (user) => ({
  config: {
    skip: !user,
  },
  params: {
    legacyUserId: user?.details?.id.toString(),
    countryCode: user?.details?.countryCode
  }
});

export const useProductAssetsByUserConfigs  = (user) => {
  const config = {
    olHeaders,
    skip: !user
  };

  return { config };
};

export const withUseQueryConfig = (hookArgs: { config?: Record<string, unknown>; [key: string]: unknown } = {}) => ({
  ...hookArgs,
  config: {
    ...(hookArgs.config || {}),
    useQuery: true,
  },
});
